export function toEnumNoCase<TEnum>(enumType: any, value: string): TEnum {
  if (!value) return null;

  const enumKeys = Object.keys(enumType);
  return enumType[enumKeys.find((k) => k.toLowerCase() === value.toLowerCase())];
}
